import { common } from '@mui/material/colors';
import { darken } from '@mui/material/styles';
export const MuiButton = (theme) => {
    const { mode, primary } = theme.palette;
    const isLight = mode === 'light';
    const containedPrimaryDark = {
        background: common.white,
        color: primary.dark,
        '&:hover': {
            color: primary.dark,
            background: primary.light
        },
        '&:disabled': {
            color: darken(primary.dark, 0.2),
            background: darken(primary.light, 0.2)
        }
    };
    const textPrimaryDark = {
        color: common.white,
        '&:hover': {
            color: common.white,
            background: darken(primary.light, 0.8)
        }
    };
    const outlinedPrimaryDark = Object.assign(Object.assign({}, textPrimaryDark), { border: `1px solid ${darken(common.white, 0.3)}`, '&:hover': Object.assign(Object.assign({}, textPrimaryDark['&:hover']), { border: `1px solid ${common.white}` }) });
    const outlinedPrimaryLight = {
        border: `1px solid ${primary.main}`,
        color: primary.main
    };
    return {
        styleOverrides: {
            root: {
                textTransform: 'none'
            },
            outlinedPrimary: isLight ? outlinedPrimaryLight : outlinedPrimaryDark,
            containedPrimary: isLight ? {} : containedPrimaryDark,
            textPrimary: isLight ? {} : textPrimaryDark
        }
    };
};
